import {
  FormGridItem,
  type FormGridItemProps,
  TextField,
  type TextFieldProps,
  useMultilineTextValidator,
} from '@ace-clublabs/shared-component-library';

import { getRequiredFieldSx } from '../utils';

const multiLineInputStyles = {
  '& .MuiInputBase-root': {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    border: 0,
    overflow: 'hidden',
  },
  '& .MuiTextField-root': {
    textAlign: 'left',
  },
  '& .MuiInputBase-inputMultiline': {
    border: '0 !important',
  },
};

export interface EmailMessageFieldProps {
  value?: string;
  onChange: (value: string) => void;
  required?: boolean;
  fieldProps?: Partial<TextFieldProps<'any-text'>>;
  validatorProps?: Parameters<typeof useMultilineTextValidator>[0];
  gridItemProps?: Partial<FormGridItemProps>;
}

export const EmailMessageField: React.FC<EmailMessageFieldProps> = ({
  value,
  onChange,
  required = false,
  fieldProps,
  validatorProps,
  gridItemProps,
}) => {
  const label = 'Email message';
  const validator = useMultilineTextValidator({
    label,
    required,
    ...validatorProps,
  });

  return (
    <FormGridItem
      size={12}
      {...gridItemProps}
      sx={getRequiredFieldSx(required)}
    >
      <TextField
        name='emailMessage'
        data-testid='emailMessage'
        onChange={(e) => onChange(e.target.value)}
        value={value}
        multiline
        fullWidth
        label={label}
        // {...defaultInputProps}
        placeholder='Type a message to your advisor.'
        validator={validator}
        sx={multiLineInputStyles}
        {...fieldProps}
      />
    </FormGridItem>
  );
};
